module.exports = __webpack_public_path__ + "static/media/GAOFEN 4.f5bf9ded.czml";